import { neftApi } from "app/config";

import {
  ApiResponse,
  SortCodeEnum,
  BatchStatusEnum,
  NIBSSStatusEnum,
  TransactionTypeEnum,
  UserPermissionsResponse
} from "models";

const configApiWithTag = neftApi.enhanceEndpoints({
  addTagTypes: ["sortcode-enum", "nibss-status-enum", "batch-status-enum", "transaction-type-enum", "user-permissions"],
});

const configApiSlice = configApiWithTag.injectEndpoints({
  
  overrideExisting: true,
  endpoints: (builder) => ({
    
    getNIBSSStatusEnum: builder.query<ApiResponse<NIBSSStatusEnum[]>, void>({
      query: () => ({
        url: `/enum/nibss-status`,
        method: "GET",
      }),
      providesTags: ["nibss-status-enum"],
      
    }),

    getTransactionTypeEnum: builder.query<ApiResponse<TransactionTypeEnum[]>, void>({
      query: () => ({
        url: `/enum/transaction-type`,
        method: "GET",
      }),
      providesTags: ["transaction-type-enum"],
    }),

    getSortCodeTypeEnum: builder.query<ApiResponse<SortCodeEnum[]>, void>({
      query: () => ({
        url: `/sort-code`,
        method: "GET",
      }),
      providesTags: ["sortcode-enum"],
    }),

    getBatchStatusEnum: builder.query<ApiResponse<BatchStatusEnum[]>, void>({
      query: () => ({
        url: `/enum/batch-status`,
        method: "GET",
      }),
      providesTags: ["batch-status-enum"],
    }),

     getUserPermissions: builder.query<UserPermissionsResponse, void>({
      query: () => ({
        url: `/user-permissions`,
        method: "GET",
      }),
      providesTags: ["user-permissions"],
    }),
  }),
});

export const {
  useGetBatchStatusEnumQuery,
  useGetNIBSSStatusEnumQuery,
  useGetUserPermissionsQuery,
  useGetSortCodeTypeEnumQuery,
  useGetTransactionTypeEnumQuery,
} = configApiSlice;

export default configApiSlice;
